export interface ShopProduct {
  id: number;
  name: string;
  price: number;
  category: string;
  image: string;
  badge?: string;
  description: string;
}

export const shopProducts: ShopProduct[] = [
  {
    id: 1,
    name: "PWA Logo Tee",
    price: 25,
    category: "T-Shirts",
    image: "https://public.readdy.ai/ai/img_res/4f4976ba37d1f74d4100a484603ea982.jpg",
    badge: "Bestseller",
    description: "Rep the PWA wherever you go. Premium cotton, bold orange print.",
  },
  {
    id: 2,
    name: "PWA Heavyweight Hoodie",
    price: 55,
    category: "Hoodies",
    image: "https://readdy.ai/api/search-image?query=black%20heavyweight%20wrestling%20hoodie%20with%20orange%20embroidered%20logo%20front%20flat%20lay%20product%20photography%20clean%20white%20background%20studio%20lighting%20professional%20apparel%20photography%20wrestling%20brand%20merchandise%20streetwear&width=400&height=400&seq=shop2&orientation=squarish",
    badge: "New",
    description: "Heavy-duty pullover hoodie with embroidered PWA crest. Built for the ring and the streets.",
  },
  {
    id: 3,
    name: "PWA Snapback Cap",
    price: 30,
    category: "Accessories",
    image: "https://readdy.ai/api/search-image?query=black%20snapback%20baseball%20cap%20with%20orange%20embroidered%20wrestling%20logo%20Pacific%20Wrestling%20Alliance%20product%20photography%20on%20clean%20white%20background%20side%20angle%20view%20studio%20lighting%20sharp%20details%20minimalist%20hat%20merchandise&width=400&height=400&seq=shop3&orientation=squarish",
    description: "Adjustable snapback with embroidered orange PWA logo. One size fits all.",
  },
  {
    id: 4,
    name: "El Chivo \"The Goat\" Tee",
    price: 30,
    category: "T-Shirts",
    image: "https://readdy.ai/api/search-image?query=grey%20wrestling%20themed%20tshirt%20with%20bold%20graphic%20print%20El%20Chivo%20The%20Goat%20lucha%20libre%20character%20design%20flat%20lay%20product%20photography%20on%20clean%20white%20background%20professional%20studio%20lighting%20commercial%20apparel%20photography%20wrestler%20merchandise&width=400&height=400&seq=shop4&orientation=squarish",
    description: "Celebrate El Chivo with this officially licensed wrestler tee. The Goat approves.",
  },
  {
    id: 5,
    name: "Eli Emerson Showstopper Tee",
    price: 30,
    category: "T-Shirts",
    image: "https://readdy.ai/api/search-image?query=white%20wrestling%20tshirt%20with%20bold%20black%20orange%20graphic%20print%20Eli%20Emerson%20Showstopper%20text%20design%20flat%20lay%20on%20clean%20white%20background%20professional%20studio%20photography%20apparel%20merchandise%20modern%20streetwear%20style&width=400&height=400&seq=shop5&orientation=squarish",
    description: "Officially licensed Eli Emerson tee. The Showstopper&#39;s signature orange and black colorway.",
  },
  {
    id: 6,
    name: "PWA Training Shorts",
    price: 40,
    category: "Accessories",
    image: "https://readdy.ai/api/search-image?query=black%20athletic%20wrestling%20training%20shorts%20with%20bold%20orange%20side%20stripe%20PWA%20logo%20flat%20lay%20product%20photography%20on%20clean%20white%20background%20professional%20studio%20lighting%20sportswear%20apparel%20athletic%20wear&width=400&height=400&seq=shop6&orientation=squarish",
    description: "Pro-grade training shorts with moisture-wicking fabric. Orange side stripe.",
  },
  {
    id: 7,
    name: "Summer Star Wars Event Poster",
    price: 20,
    category: "Collectibles",
    image: "https://readdy.ai/api/search-image?query=wrestling%20event%20poster%20print%20Summer%20Star%20Wars%20Pacific%20Wrestling%20Alliance%20colorful%20bold%20typography%20orange%20black%20vibrant%20design%20product%20flat%20lay%20on%20white%20background%20clean%20studio%20photography%20collectible%20memorabilia&width=400&height=400&seq=shop7&orientation=squarish",
    description: "Official 18x24 event poster from PWA Summer Star Wars. Numbered limited print.",
  },
  {
    id: 8,
    name: "PWA Championship Belt Replica",
    price: 150,
    category: "Collectibles",
    image: "https://readdy.ai/api/search-image?query=gold%20wrestling%20championship%20belt%20with%20ornate%20detailed%20design%20black%20leather%20strap%20PWA%20logo%20center%20plate%20professional%20product%20photography%20on%20white%20background%20studio%20lighting%20detailed%20craftsmanship%20collectible%20memorabilia%20prop%20replica&width=400&height=400&seq=shop8&orientation=squarish",
    badge: "Limited",
    description: "Full-size replica PWA Championship Belt. Gold-plated center plate with real leather strap.",
  },
];

export const shopCategories = ["All", "T-Shirts", "Hoodies", "Accessories", "Collectibles"];
